import {CodeDesignation} from 'sigale-angular';

export class DateDemandee {
	date: Date;
	duree: CodeDesignation;
	commentaire: string;
	estDureeModifiable: boolean;

	constructor(date: Date, duree: CodeDesignation, commentaire: string, estDureeModifiable: boolean) {
		this.date = date;
		this.duree = duree;
		this.commentaire = commentaire;
		this.estDureeModifiable = estDureeModifiable;
	}
}
